import MuiMenuItem from '@mui/material/MenuItem';
import { styled } from '@mui/material/styles';

export const StyledMenuItem = styled(MuiMenuItem)(({ theme }) => ({
  '&:focus-visible': {
    outline: `3px solid ${theme.palette.primary.light}`,
    outlineOffset: -3,
  },
})) as typeof MuiMenuItem;
